import { render, staticRenderFns } from "./markup.vue?vue&type=template&id=4aa95551&scoped=true&lang=pug"
import script from "./markup.vue?vue&type=script&lang=js"
export * from "./markup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa95551",
  null
  
)

/* custom blocks */
import block0 from "./markup.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports